import React from 'react'

import Global from '../../styles/global'
import LayoutDisplay from './LayoutDisplay'

const LayoutContainer = () => {
  return (
    <>
      <Global />
      <LayoutDisplay />
    </>
  )
}

export default LayoutContainer
